export const FAMILY_HISTORY = {
  key: 'FAMILY_HISTORY',
  value: 9,
  group: 1,
  title: 'health-record.family-history.title',
  menu_title: 'health-record.family-history.title',
  imageURL: require('@assets/images/Health-Record-Icons/Icon-Family-History.svg'),
  icon: 'home',
  editor: 'FamilyHistoryEditor',
  message_translate: 'health-record.family-history.message',
  model_name: 'family_history',
  resource: 'hr/familyhistory/',
  plain_resource: 'familyhistory',
  id: 'hr_id',
  headers: [
    {
      text: 'health-record.family-history.reason',
      value: 'record.medical_problem',
    },
    {
      text: 'health-record.family-history.relationship',
      value: 'record.relationship_type.value',
    },
    {
      text: 'health-record.family-history.name',
      value: 'record.family_member_name',
    },
    {
      text: 'health-record.family-history.outcome',
      value: 'record.outcome.value',
    },
    {
      text: 'health-record.actions',
      value: 'actions',
      sortable: false,
      width: '100px',
    },
  ],
  sortables: {
    record: {
      family_member_name: 'family_member_name',
      relationship_type: {
        value: 'relationship_type',
      },
      deceased: 'deceased',
      medical_problem: 'medical_problem',
      age_at_occurrence: 'age_at_occurrence',
      outcome: {
        value: 'outcome',
      },
    },
  },
  show_menu: true,
  background: 'linear-gradient(122.25deg, #5E35B1 3.07%, #7E57C2 100%)',
  color: '#7C54C1',
  opaque: '#E1D9EF',
}
